/**
 * Created by lily on 2018/9/25.
 */
import home from "./components/home.vue";
import list from "./components/recharge-list.vue";
import successBox from "./components/success.vue";
import errorBox from "./components/error.vue";
import bindBox from "./components/bind.vue";
import exchange from "./components/exchange.vue";
import emptyLayout from "./components/emptyLayout.vue"

import youKuIndex from "./components/youKu/index.vue"
import yearBag from "./components/youKu/yearBag.vue"
import forward from "./components/youKu/forward.vue"
import recordList from "./components/youKu/recordList.vue"
import hint from "./components/youKu/hint.vue"

const routes=[
    {path:"/",component:home},
    {path:"/home",component:home},
    {path:"/recharge-list",component:list},
    {path:"/success",component:successBox},
    {path:"/error",component:errorBox},
    {path:"/bind",component:bindBox},
    {path:"/exchange",component:emptyLayout,children:[
        {
            path:'',
            component: exchange,
        },
    ]},
    {path:"/youKu",component:emptyLayout,children: [
        {
            path:'index',
            component: youKuIndex,
            meta:{
                title: '半价优酷会员'
            }
        },
        {
            path:'yearBag',
            component: yearBag,
            meta:{
                title: '半价优酷会员'
            }
        },
        {
            path:'forward',
            name: 'youKuForward',
            component: forward,
            meta:{
                title: '半价优酷会员'
            }
        },
        {
            path:'recordList',
            component: recordList,
            meta:{
                title: '半价优酷会员'
            }
        },
        {
            path:'hint',
            component: hint,
            meta:{
                title: '半价优酷会员'
            }
        }
    ]},
];

export default routes;


// WEBPACK FOOTER //
// ./src/router.js